import { edgelessToolbarI18nT } from '@blocksuite/affine-shared/services';
import { SeniorToolExtension } from '@blocksuite/affine-widget-edgeless-toolbar';
import { html } from 'lit';

export const frameSeniorTool = SeniorToolExtension('frame', ({ block }) => {
  return {
    name: edgelessToolbarI18nT('toolbar.frame'),
    content: html`<edgeless-frame-tool-button
      .edgeless=${block}
    ></edgeless-frame-tool-button>`,
    priority: 90,
  };
});
